import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { ICustomerServiceFee, ICustomerServiceFeeFilter } from '../interfaces/service-fee';
import { IPageResult } from '../interfaces/page-result';

@Injectable({ providedIn: 'root' })
export class CustomerServiceFee extends ReadService<any, any> {
  url = '/api/customer-service-fee';
  entityTitle = 'Customer Service Fee';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAll(filter: ICustomerServiceFeeFilter): Promise<IPageResult<ICustomerServiceFee>> {
    let params = this.constructHttpParams(filter);
    return this.http
      .get(`${this.url}`, { headers: new HttpHeaders({}), params: params })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public create(dto: ICustomerServiceFee) {
    const url = `${this.url}`;
    return this.handleRequest<number>(
      this.http.post<number>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  public update(id: number, dto: ICustomerServiceFee) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<number>(
      this.http.put<number>(url, dto),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  public delete(id: number) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<boolean>(
      this.http.delete<boolean>(url),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }
}
